import { Box, Flex, Heading, Stack } from "@chakra-ui/react";
import { SectionTemplate } from "./section-template";
import Image from "next/image";
import { insertLineBreaks } from "utils/resolve-template";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { customRichText } from "../mdx-components";
import { Button, ButtonActions } from "@ui/components";
import { DynamicSectionProps, flexStyles, getAlign } from "./section";
import { RichTextContent } from "@graphcms/rich-text-types";
import { Gcms_ContentPosition } from "lib/cms-typings";

export const SectionWithImage = ({
  title,
  subtitle,
  buttons,
  image,
  contentPosition,
  content,
  bg,
  color,
  titleColor,
  textAlignment,
  smallText,
}: DynamicSectionProps) => {
  return (
    <SectionTemplate bg={bg} color={color}>
      <Stack
        spacing={{ base: "4", lg: "20" }}
        {...flexStyles[contentPosition as Gcms_ContentPosition]}
        alignItems="center"
      >
        {image && (
          <Box
            flex="1"
            minW={"300px"}
            position="relative"
            pb={{
              base: 5,
              lg: 0,
            }}
          >
            <Image
              {...image}
              src={image.url}
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
              sizes="50vw"
              alt={image?.alt as string}
              placeholder={
                typeof image?.blurDataURL === "string" ? "blur" : undefined
              }
              blurDataURL={
                typeof image.blurDataURL === "string"
                  ? image?.blurDataURL
                  : undefined
              }
            />
          </Box>
        )}
        <Box
          maxW={{
            base: "2xl",
            lg: smallText ? "480px" : "45%",
          }}
          textAlign={{
            base: "center",
            lg: getAlign(textAlignment),
          }}
        >
          <Box as="b">{subtitle}</Box>

          <Heading
            as="h2"
            fontSize={{
              base: 26,
              md: 34,
              lg: 38,
              xl: 45,
            }}
            letterSpacing="tight"
            fontWeight="bold"
            lineHeight={1.2}
            textColor={titleColor || "inherit"}
          >
            {insertLineBreaks(title)}
          </Heading>
          <Box
            as="div"
            pt={{
              base: 4,
              lg: 8,
            }}
          >
            <RichText
              content={content as RichTextContent}
              renderers={customRichText("black", 1.5, 8)}
            />
          </Box>

          <Flex justify={"center"}>
            {buttons?.map((button: any, idx) => (
              <Button
                key={idx}
                __type={button.buttonAction as ButtonActions}
                href={button.href as string}
                colorScheme={button?.theme}
                variant={button.variant}
                label={button.label}
                mt={{
                  base: 2,
                  lg: 5,
                }}
                py={{
                  base: "6",
                  lg: "8",
                }}
                px="5"
              />
            ))}
          </Flex>
        </Box>
      </Stack>
    </SectionTemplate>
  );
};
